/* eslint-disable @typescript-eslint/no-unused-vars */

import { MATCH_TYPES } from '../../../../app/constants/match_types';
import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('assertEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./assert-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          let isFilterCollectionValid = false;
          let isMessageValid = false;

          $scope.matchTypes = MATCH_TYPES;

          $scope.onMatchTypeChange = (matchType) => {
            $scope.component.predicates.match_type = matchType;
            ngrxStoreService.dispatch(updateComponent({ component: { predicates: { match_type: matchType } } }));
          };

          $scope.onMessageChange = ({ message }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { message } }));
          };

          $scope.onRecordsChange = (records) => {
            $scope.component.predicates.expressions = records;
          };

          $scope.onFilterCollectionValidityChange = (value) => {
            isFilterCollectionValid = value;
            $scope.onValidityChange(isFilterCollectionValid && isMessageValid);
          };

          $scope.onMatchTypeChange = (match_type) => {
            $scope.component.predicates.match_type = match_type;
            ngrxStoreService.dispatch(updateComponent({ component: { predicates: { match_type } } }));
          };

          $scope.onMessageChange = ({ message }) => {
            ngrxStoreService.dispatch(updateComponent({ component: { message } }));
          };

          $scope.$watch('component.message', function (errorMessage) {
            isMessageValid = !!errorMessage;
            $scope.onValidityChange(isFilterCollectionValid && isMessageValid);
          });
        },
      ],
    };
  },
]);
